<script setup lang="ts">
const canvasRef = ref<HTMLDivElement | null>(null)

onMounted(() => {
  const script = document.createElement('script')
  script.src = '/prebuilt/main-white.min.js'
  script.type = 'text/javascript'
  script.defer = true
  script.onload = () => {}

  if (canvasRef.value) {
    canvasRef.value.appendChild(script)
  }
})
</script>

<template>
  <div class="fixed left-0 top-0 h-full w-full">
    <div id="blob-canvas" ref="canvasRef" />
  </div>
</template>
